import type {
  AssinaturaDaTela,
  ExecucoesNoEstado,
  NegociacaoSimulacaoState,
  PassosNoEstado,
} from '../types';

export const execucoesVazias = (simulacaoId: string | null): ExecucoesNoEstado => ({
  simulacaoId,
  itens: [],
  nextCursor: null,
  hasMore: false,
  carregouMais: false,
  carregando: false,
  erro: null,
  requisicaoDaPrimeiraPagina: null,
  requisicaoDoCursor: null,
});

export const passosVazios = (execucaoId: string | null): PassosNoEstado => ({
  execucaoId,
  itens: [],
  page: 0,
  pageSize: 0,
  total: 0,
  hasNext: false,
  carregando: false,
  erro: null,
  requisicaoDaPrimeiraPagina: null,
  requisicaoDaPaginaSeguinte: null,
});

export const initialState: NegociacaoSimulacaoState = {
  superficie: 'ESCRITORIO',
  contextoAdmin: null,
  configuracaoAdmin: { dados: null, carregando: false, erro: null, requisicaoVigente: null },
  configuracaoAlteradaEm: null,
  marcoDosLogs: 0,
  execucoes: execucoesVazias(null),
  passos: passosVazios(null),
  escritorioId: null,
  requisicaoDoEscritorio: null,
  trocandoEscritorio: false,
  requisicoesEmVoo: [],
  requisicoesDescartadas: [],
  acesso: {
    podeUsar: false,
    carregadoPara: null,
    carregando: false,
    requisicaoVigente: null,
    erro: null,
  },
  formulario: { flowId: null, valores: {} },
  agente: { dados: null, carregando: false, erro: null, requisicaoId: null },
  versaoDoFormulario: 0,
  ultimaAlteracaoDoFormulario: null,
  simulacao: null,
  simulacaoDescartadaId: null,
  marcoDaSimulacao: 0,
  eventos: [],
  ultimoSeq: 0,
  seqConhecido: 0,
  temMaisEventos: false,
  leituraFinalConcluida: false,
  exportacao: { carregando: false, carregados: 0, total: 0 },
  limpoAteSeq: 0,
  carregandoEventos: false,
  erroDosEventos: null,
  falhaDaSincronizacao: { atual: false, eventos: false },
  iniciando: false,
  erroDoInicio: null,
  envio: null,
  avancando: false,
  pendentesDoAvanco: 0,
  erroDoAvanco: null,
  erroDoEncerramento: null,
  intencoes: {},
  assinatura: assinaturaVazia(null),
};

export function assinaturaVazia(assinaturaId: string | null): AssinaturaDaTela {
  return {
    requisicaoDeLeitura: null,
    requisicaoDeRegistro: null,
    assinaturaId,
    simulacaoId: null,
    dados: null,
    carregando: false,
    erro: null,
    registrando: null,
    erroDoRegistro: null,
    resultadoComFalha: null,
  };
}
